class Translations {

    protected static _instances: {[key: string]: Translations} = {};

    protected _data: {[key: string]: string}

    public constructor(data:{[key: string]: string}|undefined){
        this._data = data ?? {};
    }

    public addTranslation(key: string, value: string){
        this._data[key] = value;
    }

    public addTranslations(data: {[key: string]: string}){
        this._data = { ...this._data, ...data };
    }

    public get(key: string): string{
        return this._data[key] ?? '';
    }

    public static getInstance(context: string) {
        if(this._instances[context] ?? null){
            return this._instances[context];
        }

        return this._instances[context] = new Translations(undefined); 
    }
}

const TRANSLATIONS_KEY = 'TRANGENERAL';

export function i18n(key: string){
    return Translations.getInstance(TRANSLATIONS_KEY).get(key);
}

export function configI18n(data: {[key: string]: string}){
    Translations.getInstance(TRANSLATIONS_KEY).addTranslations(data);
}